<template>
    <el-dialog title="密码重置" :visible.sync="isShow" width="500px" @close="$emit('close')">
        <el-form ref="modelForm" :model="modelForm" label-width="90px" size="small" :rules="modelFormRules">
            
            <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" v-model="modelForm.newPassword" placeholder="请输入至少8位密码,且字母、数字和符号至少包含两种" style="width: 280px"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="newPassword1">
                <el-input type="password" v-model="modelForm.newPassword1" placeholder="请再次输入密码" style="width: 280px"></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button type="text" @click="$emit('close')">取消</el-button>
            <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
        </div>
    </el-dialog>
</template>


<script>
import qs from "qs";
export default {
   
    data() {
        const validatePassWord = (rule, value, callback) => {
            // let reg1 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
            let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,}$/;
            if (!reg.test(value)) {
                callback(new Error("请输入至少8位密码,且字母、数字和符号至少包含两种"));
            } else {
                callback();
            }
        };

        const validenewPassword1 = (rule, value, callback) => {
            if (value !== this.modelForm.newPassword) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };
        return {
            modelFormRules: {
                newPassword: [{ trigger: "blur", validator: validatePassWord, required: true }],
                newPassword1: [
                    { required: true, message: "请再次输入新密码", trigger: "blur" },
                    { validator: validenewPassword1, trigger: "blur" }
                ],
            },
            modelForm: {
                newPassword: '',
                newPassword1: ""
            },
            isShow: false,
            submitLoading: false
        }
    },
    props: {
        isPwd: {
            type: Boolean,
            default: false
        },
        userId: {
            type: String,
            default: null
        }
    },
    watch: {
        isPwd(newVal) {
            this.isShow = !!newVal;

            if(newVal) {
                this.modelForm = {
                    userId: this.userId,
                    newPassword: '',
                    newPassword1: ""
                };
            }
        }
    },
    methods: {
        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest(`/api/user/resetPassword?${qs.stringify(this.modelForm)}`)
                        .then(res => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success('修改成功');
                                this.$emit('comfirm')
                            }
                        }).catch(() => {
                            this.submitLoading = false;
                        })
                }
            })
        },
        
    },
}
</script>